import clsx from 'clsx'

type Props = {
  hasData: boolean
  src: string
  alt: string
}

export const ImageCrop = (props: Props) => {
  return (
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <div>
        {props.hasData ? (
          <div className='symbol-label'>
            <img src={props.src} alt={props.alt} className='w-100' />
          </div>
        ) : (
          <div className={clsx('symbol-label fs-5', `bg-light-primary`, `text-center`)}>No img</div>
        )}
      </div>
    </div>
  )
}
